// Roles:
const OWNER = 'Owner'

export const ACTIONS = {
  // APP?OI?NTMENTS
  CANCEL_APPOINTEMNT: 'cancel',
  CREATE_APPOINTMENT: 'create_appointment',
  RESCHEDULE_APPOINTMENT: 'reschedule',
  BULK_DELETE_APPOINTMENT: 'bulk_delete',
  BULK_ADD_CODES_TO_APPOINTMENT: 'bulk_add_codes',
  BULK_ADD_PRODUCTS: 'bulk_add_products',
  BULK_CANCEL_APPOINTMENT: 'bulk_cancel',
  // 'send_message',
  // 'bulk_add_payment',
  // 'bulk_add_tags',
  // 'add_note',
  // 'bulk_create_invoices',
  // 'bulk_mutate',
  // 'bulk_reschedule',
  // 'reschedule_recurring',
  // 'delete_recurring',
  // 'bulk_make_online',
  // 'set_client',
  // 'create_online_booking',
  // 'set_discount',
  // 'clone',
  // 'set_field',
  // 'transfer_appointments',
  // 'bulk_transfer_appointments',
  // 'bulk_schedule_messsage'

  // BULK:
  CREATE_INVOICE: 'create_invoice',
  BULK_ADD_PAYMENT: 'bulk_add_payment',
  BULK_ADD_CODES: 'bulk_add_codes'
}

// pseudo namspacing:
// permission based methods/computes start with permissions...
// role based methods/computes start with roles...
export default {
  computed: {
    // global permissions for bulk actions
    permissionsCanCreateInvoice () {
      return this.hasPermission(ACTIONS.CREATE_INVOICE, this.spaceIds, this.globalSelectedAppointments)
    },
    permissionsCanBulkAddPayment () {
      return this.hasPermission(ACTIONS.BULK_ADD_PAYMENT, this.spaceIds, this.globalSelectedAppointments)
    },
    permissionsCanBulkAddCodes () {
      return this.hasPermission(ACTIONS.BULK_ADD_CODES, this.spaceIds, this.globalSelectedAppointments)
    },
    infoTeamCount () {
      let team = this.$store.getters.getColleagues
      if (team) {
        let keys = Object.keys(team)
        if (keys) { return keys.length }
      }
      return 0
    },
    infoIsTeamAccount () {
      return this.infoTeamCount > 1
    }
  },
  methods: {
    normalizedPractitionerId (appt) {
      /* normalize practitioner_id */
      let id = this.getObjectPath(appt, 'practitioner')
      if (!id) { id = this.getObjectPath(appt, 'practitioner_id') }
      if (id) {
        if (isNaN(id)) {
          id = parseInt(id.id)
        } else {
          id = parseInt(id)
        }
      }
      return id
    },
    permissionsCanCreateInvoiceMethod (spaceIds, appointments) {
      return this.hasPermission(ACTIONS.CREATE_INVOICE, spaceIds, appointments)
    },
    rolesIsOwnerOfSpace (spaceId) {
      let space = this.$store.getters.getSpaceById(spaceId)
      if (space) {
        if (space.membership_active === false) { return false }
        if (space.role === OWNER) { return true }
      }
      return false
    },
    hasPermission (action, spaceIds, appointments) {
      if (appointments && appointments.length > 0) {
        let actorId = this.meId
        if (actorId) {
          let ownsAllAppointments = appointments.every((appt) => {
            let apptPractitionerId = this.normalizedPractitionerId(appt)
            if (!apptPractitionerId) { return false }

            return (apptPractitionerId === parseInt(actorId))
          })
          if (ownsAllAppointments) { return true }
        }
      }
      // if (!this.spaceIds) {
      //   console.warn(`computed hasPermission() - called by action: ${action} - requires that spaceIds is set on the vm`)
      // }
      if (spaceIds && spaceIds.length > 0) {
        return spaceIds.every((spaceId) => {
          let space = this.$store.getters.getSpaceById(spaceId)
          if (space) {
            if (!space.membership_active) { return false }
            if (space.role === OWNER) { return true }
            // console.log(space.enabled_actions, action)
            if (space.enabled_actions && space.enabled_actions.length > 0) {
              return space.enabled_actions.indexOf(action) !== -1
            }
          }
          return false
        })
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/permissions.js